"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var wrap = function (method) { return function (color, amount) { return tinycolor2_1.default(color)[method](amount).toString(); }; };
exports.lit = wrap('lighten');
exports.brg = wrap('brighten');
exports.drk = wrap('darken');
exports.des = wrap('desaturate');
exports.sat = wrap('saturate');
exports.gry = wrap('greyscale');
exports.spin = wrap('spin');
exports.alp = wrap('setAlpha');
exports.mix = function (color1, color2, amount) {
    return tinycolor2_1.default.mix(tinycolor2_1.default(color1), tinycolor2_1.default(color2), amount).toString();
};
